import Booking from '../../core/types/model/Booking';

export type BookingColumnLayout = {
  rowStart: number;
  rowEnd: number;
  columnStart: number;
  columnEnd: number;
  booking: Booking;
  expanded: boolean;
  halfHeight: boolean;
  concurrentBookingIds: Set<number>;
  hasRightWiseBooking?: boolean;
  halfWidth?: boolean;
};

export type BookingPlacement = {
  layouts: BookingColumnLayout[];
  overflowRows: number[];
};

export type TimeSlotDefinition = {
  index: number;
  startTime: string;
  rowSpan: 1 | 2; // 1 = 30 minutes, 2 = 60 minutes
  onHour: boolean;
};

export enum BookingLayout {
  Calendar,
  List
}

export type BookingSortFilter = keyof Booking;
